import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import {
    Form,
    Input,
    Button,
    DatePicker,
    Table,
    Spin,
} from "antd";
import ListPagination, {
    LIST_DEFAULT_PAGE_SIZE,
    buildPageQuery,
    createPageChangeHandler,
    parseTotalFromPayload,
} from "../../components/ListPagination";
import API, { CONVERSION_HIS, CONVERSION_HIS_EXCEL } from "../../network/api";
import moment from "moment";
import "moment-timezone";
import { TEXT_DEF } from "../../constant/text";
import Modal from 'react-bootstrap/Modal';
import {
  buildUsernameDataFilter,
  consumeUsernameFilterForHistory,
} from "../../utils/historyUsernameFilter";

const dollarUS = Intl.NumberFormat("en-US");

const TEXT = {
    rechargeAmount: 'Tiền nạp',
    DTCBanCa: 'DTC Bắn Cá',
    DTCSlot: 'DTC Slot',
    DTCCasino: 'DTC Casino',
    DTCGameViet: 'DTC Game Việt',
    DTCTheThao: 'DTC Thể Thao',
    remainingDTCBanCa: 'DTC Bắn Cá còn lại sau khi quy đổi',
    remainingDTCSlot: 'DTC Slot còn lại sau khi quy đổi',
    remainingDTCCasino: 'DTC Casino còn lại sau khi quy đổi',
    remainingDTCTGameViet: 'DTC Game Việt còn lại sau khi quy đổi',
    remainingDTCTheThao: 'DTC Thể Thao còn lại sau khi quy đổi',
    turn: 'Lượt chơi',
    time: 'Thời gian',
}

const HistoryList = () => {
    const location = useLocation();
    const initialUsername = consumeUsernameFilterForHistory(location);
    const [form] = Form.useForm();
    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();
    const [dataList, setDataList] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(LIST_DEFAULT_PAGE_SIZE);
    const [totalRecord, setTotalRecord] = useState(0);
    const locale = {
        emptyText: TEXT_DEF.text0035,
    };

    const [loading, setLoading] = useState(false);
    const [dataFilter, setDataFilter] = useState(() =>
        buildUsernameDataFilter(initialUsername)
    );

    const [isShowModalDetail, setIsShowModalDetail] = useState(false);
    const [dtcRemainingSl, setDTCRemainingSl] = useState();

    const getListData = useCallback(async () => {
        setLoading(true);
        const { query: pageQuery } = buildPageQuery(page, pageSize);
        const dataList1 = API.get(
            `${CONVERSION_HIS}?${pageQuery}${dataFilter ? `&${dataFilter}` : ""}`
        );

        await Promise.all([dataList1])
            .then((response) => {
                const res = response[0].data.data.data;
                if (res) {
                    let dataCV = [];
                    res?.map((item) => {
                        const user = {
                            key: item?.id,
                            username: item?.username,
                            rechargeAmount: item?.minDeposit,
                            createdAt: item?.createdAt,
                            turn: item?.totalTurns,
                            DTCBanCa: item?.dtcBanCa,
                            DTCSlot: item?.dtcSlots,
                            DTCCasino: item?.dtcCasino,
                            DTCGameViet: item?.dtcGameViet,
                            DTCTheThao: item?.dtcTheThao,
                            dtcRemaining: {
                                DTCBanCa: item?.dtcBanCaRemaining.toFixed(2),
                                DTCSlot: item?.dtcSlotsRemaining.toFixed(2),
                                DTCCasino: item?.dtcCasinoRemaining.toFixed(2),
                                DTCGameViet: item?.dtcGameVietRemaining.toFixed(2),
                                DTCTheThao: item?.dtcTheThaoRemaining.toFixed(2),
                            },
                        };
                        dataCV.push(user);
                        return dataCV;
                        // dataUserCV = dataUserCV.sort((a, b) => (moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()))
                    });

                    setDataList(dataCV);
                    const pagePayload = response[0].data?.data;
                    setTotalRecord(parseTotalFromPayload(pagePayload, dataCV.length));
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    }, [page, pageSize, dataFilter]);

    useEffect(() => {
        if (initialUsername) {
            form.setFieldValue("usernameFilter", initialUsername);
        }
    }, [form, initialUsername]);

    useEffect(() => {
        getListData();
    }, [getListData]);

    const onChangePage = createPageChangeHandler(
        page,
        pageSize,
        setPage,
        setPageSize
    );

    const onSearch = () => {
        let params = '';
        if (form.getFieldValue("usernameFilter"))
            params += `username=${form.getFieldValue("usernameFilter").trim().toLowerCase()}`;
        if (form.getFieldValue("userStatus"))
            params += params !== '' ? `&status=${form.getFieldValue("userStatus")}` : `status=${form.getFieldValue("userStatus")}`;
        if (dateFrom) {
            params += params !== '' ? `&fromDate=${moment(dateFrom).format("YYYY-MM-DD")}` : `fromDate=${moment(dateFrom).format("YYYY-MM-DD")}`;
        }
        if (dateTo) {
            params += params !== '' ? `&toDate=${moment(dateTo).format("YYYY-MM-DD")}` : `toDate=${moment(dateTo).format("YYYY-MM-DD")}`;
            params += !dateFrom ? `&fromDate=${moment('2025-07-15').format("YYYY-MM-DD")}` : '';
        }

        if (params !== '') {
            setDataFilter(params);
        } else {
            setDataFilter(null);
        }
    };

    const dataColums = [
        {
            title: "STT",
            key: "stt",
            width: 60,
            render: (text, record, index) => (page - 1) * 10 + index + 1,
        },
        {
            title: TEXT_DEF.text0002,
            dataIndex: "username",
            key: "username",
        },
        {
            title: TEXT.rechargeAmount,
            key: "rechargeAmount",
            render: (record) => dollarUS.format(Number(record.rechargeAmount)),
        },
        {
            title: TEXT.DTCBanCa,
            key: "DTCBanCa",
            dataIndex: "DTCBanCa",
        },
        {
            title: TEXT.DTCSlot,
            key: "DTCSlot",
            dataIndex: "DTCSlot",
        },
        {
            title: TEXT.DTCCasino,
            key: "DTCCasino",
            dataIndex: "DTCCasino",
        },
        {
            title: TEXT.DTCGameViet,
            key: "DTCGameViet",
            dataIndex: "DTCGameViet",
        },
        {
            title: TEXT.DTCTheThao,
            key: "DTCTheThao",
            dataIndex: "DTCTheThao",
        },
        {
            title: 'DTC còn lại',
            key: "dtcRemaining",
            render: (record) => 
                <p onClick={() => showDTCRemaining(record)} className="m-0 cursor-pointer" style={{ color: "rgb(22, 119, 255)" }}>{`Chi tiết`}</p>,
        },
        {
            title: TEXT.turn,
            key: "turn",
            dataIndex: "turn",
        },
        {
            title: 'Thời gian',
            key: "createdAt",
            dataIndex: "createdAt",
            render: (value) =>
                moment(value).format("DD-MM-YYYY HH:mm:ss"),
        },
    ];

    const showDTCRemaining = (record) => {
        const dtcRemaining = record?.dtcRemaining;
        setDTCRemainingSl(dtcRemaining);
        setIsShowModalDetail(true);
    }


    const onChangeDate = (e, type) => {
        if (e) {
            if (type === "from") setDateFrom(moment(e.$d).startOf("day").format('yyyy-MM-DD'));
            else setDateTo(moment(e.$d).endOf("day").format('yyyy-MM-DD'));
        } else {
            if (type === "from") setDateFrom(null);
            else setDateTo(null);
        }
    };

    const handleDownloadExcel = async () => {
        await API.post(
            `${CONVERSION_HIS_EXCEL}?${dataFilter ? `&${dataFilter}` : ""}`,
            {},
            { responseType: 'blob' })
                .then(async (response) => {
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;

                    // Optional: lấy tên file từ response header nếu có
                    const disposition = response.headers.get('Content-Disposition');
                    let fileName = 'lich_su_quy_doi.xlsx';
                    if (disposition && disposition.includes('filename=')) {
                        fileName = disposition.split('filename=')[1].replace(/"/g, '');
                    }

                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    console.log(error);
                    setLoading(false);
                });
    };

    const renderHistory = () => {
        return (
            <>
                <div className="col-12">
                    <Form
                        form={form}
                        layout="inline"
                        autoComplete="off"
                        onFinish={() => onSearch()}
                    >
                        <div
                            className="col-12"
                            style={{ marginBottom: 15, display: "flex" }}
                        >
                            <div className="col-5">
                                <Form.Item name="usernameFilter" label={TEXT_DEF.text0002}>
                                    <Input style={{ width: "100%" }} />
                                </Form.Item>
                            </div>
                        </div>

                        <div
                            className="col-12"
                            style={{ marginBottom: 15, display: "flex" }}
                        >
                            <div className="col-5">
                                <Form.Item name="dateFrom" label={TEXT_DEF.text0032}>
                                    <DatePicker
                                        placeholder=""
                                        onChange={(e) => onChangeDate(e, "from")}
                                        format={"DD-MM-YYYY"}
                                        style={{ width: "100%" }}
                                        disabledTime={(d) =>
                                            !d ||
                                            d.isSameOrAfter(
                                                dateTo ? moment(dateTo).add(1, "d") : moment()
                                            )
                                        }
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-5">
                                <Form.Item name="dateTo" label={TEXT_DEF.text0033}>
                                    <DatePicker
                                        placeholder=""
                                        onChange={(e) => onChangeDate(e, "to")}
                                        format={"DD-MM-YYYY"}
                                        style={{ width: "100%" }}
                                        disabledTime={(d) =>
                                            !d ||
                                            d.isSameOrBefore(dateFrom ? dateFrom : null) ||
                                            d.isSameOrAfter(moment())
                                        }
                                    />
                                </Form.Item>
                            </div>
                        </div>

                        <div className="payment-search">
                            <Button htmlType="submit" type="primary">
                                {TEXT_DEF.text0031}
                            </Button>
                            <Button
                                style={{ marginLeft: 20 }}
                                onClick={handleDownloadExcel}
                                htmlType="button"
                                type="primary"
                            >
                                {TEXT_DEF.text0050}
                            </Button>
                        </div>
                    </Form>
                </div>

                <Spin spinning={loading} delay={500} size="large">
                    <div style={{ display: "flex", width: "100%", marginTop: 20 }}>
                        <Table
                            key="conversionList"
                            locale={locale}
                            columns={dataColums}
                            dataSource={dataList}
                            pagination={false}
                            bordered
                            style={{ width: "100%" }}
                        />
                    </div>
                    <ListPagination
                        current={page}
                        total={totalRecord}
                        pageSize={pageSize}
                        onChange={onChangePage}
                        unit="dữ liệu"
                    />
                </Spin>
            </>
        );
    };

    return (
        <div className="col-12">
            {renderHistory()}
            {isShowModalDetail && (
                <Modal show={isShowModalDetail} className='modal-all' onHide={() => setIsShowModalDetail(false)}>
                    <Modal.Header>
                        <div className="flex flex-col w-full items-center justify-center">
                            <h5>DTC còn lại sau khi đổi lượt chơi</h5>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="flex flex-col w-full items-center justify-center">
                            <p><strong>{`${TEXT.DTCBanCa}: `}</strong>{dtcRemainingSl?.DTCBanCa}</p>
                            <p><strong>{`${TEXT.DTCSlot}: `}</strong>{dtcRemainingSl?.DTCSlot}</p>
                            <p><strong>{`${TEXT.DTCCasino}: `}</strong>{dtcRemainingSl?.DTCCasino}</p>
                            <p><strong>{`${TEXT.DTCGameViet}: `}</strong>{dtcRemainingSl?.DTCGameViet}</p>
                            <p><strong>{`${TEXT.DTCTheThao}: `}</strong>{dtcRemainingSl?.DTCTheThao}</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="default" onClick={() => setIsShowModalDetail(false)}>
                            Đóng
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    );
};

export default HistoryList;
